<template>
  <div class="app-content">
    <div v-for="tab in this.tabs" :key="tab.id + '-component'" style="position: relative; top: 0px;">
      <transition name="fade">
        <component :is="tab.component" v-bind="tab.props" v-if="tab.isActive" />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

import WorkStockIndex from './WorkStockIndex.vue';
import WorkStockDetails from '@/views/components/work-stock-details/WorkStockDetails.vue';

export default {
  name: 'WorkStock',
  components: {
    Button,
    WorkStockIndex,
    WorkStockDetails
  },
  computed: {
    ...mapGetters({
      tabs: 'workStockTabs'
    })
  }
};
</script>

<style lang="scss" scoped>

</style>
